export class Details {
    constructor(props) {
        this.detailsElement = undefined;
        this.summaryElement = undefined;
        this.icon = undefined;
        this.detailsElement = props.detailsElement;
        this.summaryElement = this.detailsElement.querySelector(".js-details-summary");
        this.icon = this.summaryElement.querySelector(".js-summary-icon use");
        if (!this.detailsElement || !this.summaryElement || !this.icon) {
            console.error("Details, summary or icon missing");
            return;
        }
        this.openIcon = props.openIcon || "#icon-sorted-down";
        this.closeIcon = props.closeIcon || "#icon-sorted-up";
        this.detailsElement.addEventListener("toggle", () => {
            const isOpen = this.detailsElement.open;
            const iconPath = `/bundles/img/svg-icons/symbols.svg${isOpen ? this.closeIcon : this.openIcon}`;
            this.icon.setAttribute("xlink:href", iconPath);
            const openTableTextElem = this.summaryElement.querySelector(".js-details-closed");
            const closeTableTextElem = this.summaryElement.querySelector(".js-details-opened");
            if (isOpen) {
                openTableTextElem.classList.add("u-hidden");
                closeTableTextElem.classList.remove("u-hidden");
            }
            else {
                openTableTextElem.classList.remove("u-hidden");
                closeTableTextElem.classList.add("u-hidden");
            }
        });
    }
}
Details.init = () => {
    const details = document.querySelectorAll(".js-details");
    details.forEach((details) => {
        const config = {
            detailsElement: details,
        };
        new Details(config);
    });
};
